import { xyz_n_1of4, xyz_n_DemosAndRetrospective, xyz_7_FinalExam, xyz_7_LastRegularSession, insertInto } from './SL00000Sprint00TTR'

import { basicSlide, orderedListSlide } from './SLSprint00'
import { sprintPlanningSlideDeck } from './SLSprintPlanning'

import { list44000Sprint06 } from '../ActivityLists/AL44000Sprint06'
import { list44000Sprint07 } from '../ActivityLists/AL44000Sprint07'

import { submissionPercentage } from './SLSprint00'

// Software Engineering (SE) sprint 7 global values.
const sprint = 7
const activityList = () => { return list44000Sprint07(sprint) }
const activityListPrevious = () => { return list44000Sprint06(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const se_7_1of4 = () => { 
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with a Discussion, Lab, and Reflection',
			`Similar in that we will have 2 weeks to complete sprint ${sprint}`,
			`Similar in that we have sprint ${sprint-1} Demos and Retrospectives Thursday`,
			`Different in that Lab ${sprint} - Planning will be due by the end of the day Thursday`,
			`Different in that we have our Final Exam will be next Tuesday with in person attendance required`,
			`Different in that the Final Exam replaces the Quiz for the sprint`,
			`Different in that we will do Sprint ${sprint+1} Planning during sprint ${sprint}`,
		 ])
	}
	const activitiesReviewSprint8 = () => {
		return basicSlide('Sprint 8 Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the Sprint 8 activity list and assignments together.' ])
	}

	const slideDeck = xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations)

	const insertAfterActivitiesReview = 6
	const slideDeckWithSprint8Review =insertInto(slideDeck, activitiesReviewSprint8, insertAfterActivitiesReview)

	const insertAfterRecap = 9
	return insertInto(slideDeckWithSprint8Review, sprintPlanningSlideDeck(sprint), insertAfterRecap+1)
}

// Session 2 of 4: Tuesday
const se_7_2of4_PAaA = {
	'prework':[
		'Complete through activity 5',
		'Be prepared for Demos and Retrospectives' ],
	'announcements':[ 
		`Tuesday is your final exam with in-person attendance required`, '',
	],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class',
		'Lab' ],
}
const se_7_2of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Lab - Planning', due:24, submitted:22 },
			{ name: 'Discussion', due:24, submitted:23 },
			{ name: 'Quiz', due:24, submitted:24 },
			{ name: 'Lab', due:24, submitted:24 },
			{ name: 'Reflection', due:24, submitted:24}])
	}
	const retrospective = () => {
			return orderedListSlide('Class Retrospective',
				'Feedback from Assignments & Reflections', [
				`Excellent submission percentage in sprint ${sprint-1}`,
				`Many assignments have not been graded yet`,
				`I am impressed by the work you are doing in your teams... well done!` ])
	}	

	return xyz_n_DemosAndRetrospective(se_7_2of4_PAaA, se_7_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

const se_7_3of4_PAaA = {
	'prework':[
		'Complete through activity 7', '',
		'Be prepared for your final exam... with in-person attendance required' ],
	'announcements':[ 
		`All sprint ${sprint} assignments are due Sunday`, 
		'Class Project Presentations are next week... Verify your date and time for your Class Project Presentation',
	],
	'agenda':[
		'Review Class Project Presentation Dates/Times and Expectations',
		'Final Exam'
	],
}

const se_7_3of4 = () => { 
	return xyz_7_FinalExam(se_7_3of4_PAaA, se_7_4of4_PAaA, sprintAndActivityLists)
}

const se_7_4of4_PAaA = {
	'prework':[
		'Complete through activity 8', '',
		'Be prepared for Lab and ”Working with India”' ],
	'announcements':[ 
		`All sprint ${sprint} announcements due Sunday`, 
		'Please verify your date and time for your Class Project Presentation',
		'You should have received an email with course evaluation information', 
	],
	'agenda':[
		'Review Class Project Presentation Dates/Times and Expectations',
		'Lab',
		'Globalization and Working with India'
	],
}

const se_7_4of4 = () => {
	return xyz_7_LastRegularSession(se_7_4of4_PAaA, se_8_1of1_PAaA, sprintAndActivityLists)
}

const se_8_1of1_PAaA = {
	'prework':[
		'All sprint 7 assignment are due Sunday', '',
		`Prepare for your Class Project Presentation`,
		'All Sprint 8 assignments are due Wednesday' ],
	'announcements':[
		'TBD' ] ,
	'agenda':[
		'TBD' ]
}


export const se_7_slidedeckTTR = [ se_7_1of4, se_7_2of4, se_7_3of4, se_7_4of4 ]
